const regexMap = {
  name: /^[ a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{0,150}$/,
  charityName: /.{0,150}$/g,
  phone: /^[0-9+()-]{0,25}$/, 
  phoneWithCharacters:/^[A-Za-z0-9)\(+=._-]*$/,   
  uszipCode: /^([0-9]{5}\-[0-9]{4})$|^([0-9]{5})$/,
  zipcode: /^[0-9-]{0,20}$/,
  nonUSZipCode: /^.{0,20}$/, //Allowing all characters to the nonUS zipcode with 20 char restriction.
  city: /^[A-Za-z-\.\s\']{0,100}$/,
  percent: /^[0-9]{0,3}$/,
  email:/^$|^\S+@\S+\.\S+$/,
  numbers: /^[0-9]*$/, //** No decimal points accepted */
  state:/^[ a-zA-Z,-\.\s]{0,50}$/,
  twoDecimal: /^[0-9]*(\.[0-9]{0,2})?$/,
  percentWDecimal: /^([0-9]{0,3})(\.[0-9]{0,2})?$/,
  emailRegEx: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  auth0emailRegEx: /^\w+([.-]\w+)*@\w+([.-]\w+)*\.\w+([.-]\w+)*$/,
  ssn: /^[0-9a-zA-Z]{0,4}$/,
  AccountNameRegEx: /^(?=(.*[0-9]){2,})|(?=(.*[A-Za-z]){2,}).*/,
  password: {
      charCount: /^.{8,32}$/g,
      lowerCase: /[a-z]/g,
      upperCase: /[A-Z]/g,
      numCount: /\d/g,
      space: /\s/g,
      specialChar: /[-!@#$%^&*()_+=|\\~`{}\[\]:";'<>?,.\/]/g
  },
  einRegex: /^([0-9]{2}\-[0-9]{7})$|^([0-9]{9})$/,
  spaceRegex: /^[^-\s].+$/,
  eliminateSpace: /^[^-\s].*$/,
  eliminatePipe: /^[^|]*$/,
  eliminateSpecialCharacter: /((<(.|\n)*?>))|((>(.|\n)*?<))|(^(?![^|]*$))/, /** Check for ‘|’ and combination of ‘<’ and ‘>’ */
};
export default regexMap;
